import { createSlice } from '@reduxjs/toolkit';
import get from 'lodash/get';

export const initialState = {};

const userNotificationSettingsSlice = createSlice({
  name: 'userNotificationSettings',
  initialState,
  reducers: {
    setUserNotificationSettingsAction: (state, action) => {
      return {
        ...state,
        [action.payload.projectId]: {
          settings: action.payload.settings,
          loading: false,
          saveError: false,
        },
      };
    },
    setUserNotificationSettingsIsLoadingAction: (state, action) => {
      return {
        ...state,
        [action.payload.projectId]: {
          ...(state[action.payload.projectId] || {}),
          loading: true,
          saveError: false,
        },
      };
    },
    setSaveErrorUserNotificationSettingsAction: (state, action) => {
      return {
        ...state,
        [action.payload.projectId]: {
          ...(state[action.payload.projectId] || {}),
          loading: false,
          saveError: true,
        },
      };
    },
  },
});

// Actions
const {
  setUserNotificationSettingsAction,
  setUserNotificationSettingsIsLoadingAction,
  setSaveErrorUserNotificationSettingsAction,
} = userNotificationSettingsSlice.actions;

export const setUserNotificationSettings = (projectId, settings) =>
  setUserNotificationSettingsAction({ projectId, settings });

export const setUserNotificationSettingsIsLoading = (projectId) =>
  setUserNotificationSettingsIsLoadingAction({ projectId });

export const setSaveErrorUserNotificationSettings = (projectId) =>
  setSaveErrorUserNotificationSettingsAction({ projectId });

// Selectors
export const getUserNotificationSettingsSelector = (projectId) => (state) => {
  return (
    state.userNotificationSettings[projectId] || {
      loading: false,
      saveError: false,
      settings: { receiveEmails: false },
    }
  );
};

export const getSaveErrorUserNotificationSettingsSelector =
  (projectId) => (state) =>
    get(state, ['userNotificationSettings', projectId, 'saveError'], false);

export default userNotificationSettingsSlice.reducer;
